///THIS IS FOR FILTERS NOT APP SEARCH
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        searchData: {
            per_page: 12,
            page: 1,
            filters: [], //Selected filters IDS
            keywords: [],
            pageFilter: {}
        },
        filters: {}, // list of all filters converted to multidimensional array
        selectedFilterList: {}, //Selected filters objects
        searchResults: {}, //Reults from server ajax with recipes and page information
        searchList: {}, // Saved searhed result only recipes
        searchSend: false, // waiting for ajax to complete
    },
    mutations: {
        setFilters(state,val){
            state.filters = val;
        },
        unsetSearchList(state) {
            state.searchData.page = 1;
            state.searchList = {};
        },
        unsetSelectedFilterList(state) {

            Object.keys(state.selectedFilterList).forEach(function (index) {
                state.selectedFilterList[index].selected =false;
            });
            state.searchData.page = 1;
            state.selectedFilterList = {};
            state.searchData.filters = [];
            state.searchData.keywords = [];
            state.searchList = {};
        }
    },
    actions: {
        getRecipes(store, delay) {
            if (store.state.searchSend) return 0;

            if (delay) {
                store.state.searchSend = true;
            }

            const url = store.rootState.shared.api_url;
            //console.log(store.state.searchData);
            axios.post(url + "recipes", store.state.searchData)
                    .then((response) => {

                        store.state.searchResults = response.data;
                        store.state.searchSend = false;
                        response.data.data.map((el) => {
                            store.state.searchList[el.id] = el
                        });
                    })
                    .catch((error) => {
                        console.log(error.responseText);
                    });

        }
    },
    getters: {}
}
